import { render, staticRenderFns } from "./DriverSMSForm.vue?vue&type=template&id=2f382276&scoped=true"
import script from "./DriverSMSForm.vue?vue&type=script&lang=js"
export * from "./DriverSMSForm.vue?vue&type=script&lang=js"
import style0 from "./DriverSMSForm.vue?vue&type=style&index=0&id=2f382276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f382276",
  null
  
)

export default component.exports